
import type { FlowNodeData } from "./FlowNodeTypes";

export const createNodeClickHandler = (id: string, data: FlowNodeData) => {
  return (e: React.MouseEvent) => {
    // Auto-select this node when clicked
    if (data.onNodeSelect && typeof data.onNodeSelect === 'function') {
      try {
        data.onNodeSelect(id);
      } catch (error) {
        console.error("Error calling onNodeSelect for node:", id, error);
      }
    }
    
    // Only prevent dragging when actively interacting with form elements
    const target = e.target as HTMLElement;
    const isActivelyEditing = target.tagName === 'TEXTAREA' || 
                             target.tagName === 'INPUT' ||
                             target.closest('[role="combobox"][aria-expanded="true"]') ||
                             target.closest('[role="listbox"]');
    
    if (isActivelyEditing) {
      e.stopPropagation();
    }
  };
};
